import React from 'react';
import Header from '../Header/Header';

export default class NotFoundPage extends React.Component {
  render() {
    return (
      <div data-testid="error-page">
        <Header page="404 - Not Found" />
      </div>
    );
  }
}
